import { Player } from '@lottiefiles/react-lottie-player';
import styled from 'styled-components';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;
`;

export const ItemContainer = styled.button<{ $selected?: boolean }>`
  width: 100%;
  padding: 16px 20px;
  border-radius: 8px;
  background: ${({ $selected }) =>
    $selected
      ? 'linear-gradient(95.02deg, #D9002F 0%, #7F001C 100%)'
      : 'rgba(255, 255, 255, 0.1)'};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const PlayIcon = styled.div`
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
`;

export const ItemText = styled.span<{ $selected?: boolean }>`
  color: #fff;
  font-size: 16px;
  font-weight: ${({ $selected }) => ($selected ? '600' : '400')};
  margin-bottom: 8px;
`;

export const WaveformImage = styled.img`
  max-width: 300px;
  width: 100%;
  height: 24px;
`;

export const StyledPlayer = styled(Player)`
  height: 24px;
  max-width: 300px;
`;
